// extracted by mini-css-extract-plugin
export default {"Wrapper":"styles_Wrapper__rutS0","Editor":"styles_Editor__GWbN9","Toolbar":"styles_Toolbar__bRpW8","Viewer":"styles_Viewer__Y+kk2"};